export const QA_NAME_PROVIDER_CREATION_MODAL = 'create_provider'
